<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Modificación de Alcance"
          directory="Acreditados"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accAppId: String,
  },
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "send",
          name: "Alcances Acreditados",
          component: "scopes-evaluator-all-index",
          permission: "",
        },
      ],
    };
  },
  created() {
    this.getActivity();
  },
  methods: {
    returnPage() {
      window.location.href = `/accreditationtechnical/modifyScopes?tab=Modificación%20de%20Alcances%20Activo`;
    },
    data() {},
    getActivity() {
      axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.accAppId}?accApp=1`
        )
        .then((res) => {
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
          this.$store.state.accreditation.currentStatus = 620;
        });
    },
  },
};
</script>

<style></style>
